import { defineMessages, MessageDescriptor } from 'react-intl';

export const JiraServiceManagementTemplateMessages = defineMessages({
	'it-service-managementName': {
		id: 'jsm.templates.it-service-management.name',
		defaultMessage: 'IT service management',
	},
	'it-service-managementOneLinerHeadline': {
		id: 'jsm.templates.it-service-management.oneLinerHeadline',
		defaultMessage: 'Intake requests, set up alerts, raise incidents, and fix issues quickly.',
	},
	'it-service-managementIconName': {
		id: 'jsm.templates.it-service-management.templateIcon.name',
		defaultMessage: 'Jira roadmap',
	},
	'it-service-managementIconDescription': {
		id: 'jsm.templates.it-service-management.templateIcon.description',
		defaultMessage: 'Jira roadmap',
	},
	'it-service-managementFeature-1': {
		id: 'jsm.templates.it-service-management.feature-1',
		defaultMessage: 'Alerts and on-call schedules',
	},
	'it-service-managementFeature-2': {
		id: 'jsm.templates.it-service-management.feature-2',
		defaultMessage: 'Multi-channel support',
	},
	'advanced-it-service-managementName': {
		id: 'jsm.templates.advanced-it-service-management.name',
		defaultMessage: 'Advanced IT service management',
	},
	'advanced-it-service-managementOneLinerHeadline': {
		id: 'jsm.templates.advanced-it-service-management.oneLinerHeadline',
		defaultMessage: 'Incident, change, and problem management with ITSM best practices.',
	},
	'advanced-it-service-managementIconName': {
		id: 'jsm.templates.advanced-it-service-management.templateIcon.name',
		defaultMessage: 'Help Center screenshot',
	},
	'advanced-it-service-managementIconDescription': {
		id: 'jsm.templates.advanced-it-service-management.templateIcon.description',
		defaultMessage: 'Help Center screenshot',
	},
	'advanced-it-service-managementFeature-1': {
		id: 'jsm.templates.advanced-it-service-management.feature-1',
		defaultMessage: 'Automated change requests',
	},
	'advanced-it-service-managementFeature-2': {
		id: 'jsm.templates.advanced-it-service-management.feature-2',
		defaultMessage: 'Alerts and on-call schedules',
	},
	'hr-service-managementName': {
		id: 'jsm.templates.hr-service-management.name',
		defaultMessage: 'HR service management',
	},
	'hr-service-managementOneLinerHeadline': {
		id: 'jsm.templates.hr-service-management.oneLinerHeadline',
		defaultMessage: 'Manage onboarding and offboarding and respond to HR requests.',
	},
	'hr-service-managementIconName': {
		id: 'jsm.templates.hr-service-management.templateIcon.name',
		defaultMessage: 'Jira roadmap',
	},
	'hr-service-managementIconDescription': {
		id: 'jsm.templates.hr-service-management.templateIcon.description',
		defaultMessage: 'Jira roadmap',
	},
	'hr-service-managementFeature-1': {
		id: 'jsm.templates.hr-service-management.feature-1',
		defaultMessage: 'Self-service and FAQ help center',
	},
	'hr-service-managementFeature-2': {
		id: 'jsm.templates.hr-service-management.feature-2',
		defaultMessage: 'Customizable request forms',
	},
	'customer-service-managementName': {
		id: 'jsm.templates.customer-service-management.name',
		defaultMessage: 'Customer service management',
	},
	'customer-service-managementOneLinerHeadline': {
		id: 'jsm.templates.customer-service-management.oneLinerHeadline',
		defaultMessage: 'Deliver great service experiences for your external customers.',
	},
	'customer-service-managementIconName': {
		id: 'jsm.templates.customer-service-management.templateIcon.name',
		defaultMessage: 'Jira roadmap',
	},
	'customer-service-managementIconDescription': {
		id: 'jsm.templates.customer-service-management.templateIcon.description',
		defaultMessage: 'Jira roadmap',
	},
	'customer-service-managementFeature-1': {
		id: 'jsm.templates.customer-service-management.feature-1',
		defaultMessage: 'Developer escalations',
	},
	'customer-service-managementFeature-2': {
		id: 'jsm.templates.customer-service-management.feature-2',
		defaultMessage: 'Self-service and FAQ help center',
	},
	'marketing-service-managementName': {
		id: 'jsm.templates.marketing-service-management.name',
		defaultMessage: 'Marketing service management',
	},
	'marketing-service-managementOneLinerHeadline': {
		id: 'jsm.templates.marketing-service-management.oneLinerHeadline',
		defaultMessage: 'Manage and track all your marketing requests.',
	},
	'marketing-service-managementIconName': {
		id: 'jsm.templates.marketing-service-management.templateIcon.name',
		defaultMessage: 'Jira roadmap',
	},
	'marketing-service-managementIconDescription': {
		id: 'jsm.templates.marketing-service-management.templateIcon.description',
		defaultMessage: 'Jira roadmap',
	},
	'marketing-service-managementFeature-1': {
		id: 'jsm.templates.marketing-service-management.feature-1',
		defaultMessage: 'Forms for Marketing requests',
	},
	'marketing-service-managementFeature-2': {
		id: 'jsm.templates.marketing-service-management.feature-2',
		defaultMessage: 'Reports',
	},
	'design-service-managementName': {
		id: 'jsm.templates.design-service-management.name',
		defaultMessage: 'Design service management',
	},
	'design-service-managementOneLinerHeadline': {
		id: 'jsm.templates.design-service-management.oneLinerHeadline',
		defaultMessage: 'Manage and track all your design requests.',
	},
	'design-service-managementIconName': {
		id: 'jsm.templates.design-service-management.templateIcon.name',
		defaultMessage: 'Help Center screenshot',
	},
	'design-service-managementIconDescription': {
		id: 'jsm.templates.design-service-management.templateIcon.description',
		defaultMessage: 'Help Center screenshot',
	},
	'design-service-managementFeature-1': {
		id: 'jsm.templates.design-service-management.feature-1',
		defaultMessage: 'Self-service and FAQ help center',
	},
	'design-service-managementFeature-2': {
		id: 'jsm.templates.design-service-management.feature-2',
		defaultMessage: 'Automated design workflows',
	},
	'finance-service-managementName': {
		id: 'jsm.templates.finance-service-management.name',
		defaultMessage: 'Finance service management',
	},
	'finance-service-managementOneLinerHeadline': {
		id: 'jsm.templates.finance-service-management.oneLinerHeadline',
		defaultMessage: 'Manage and track budget, spend, and other finance requests.',
	},
	'finance-service-managementIconName': {
		id: 'jsm.templates.finance-service-management.templateIcon.name',
		defaultMessage: 'Form view',
	},
	'finance-service-managementIconDescription': {
		id: 'jsm.templates.finance-service-management.templateIcon.description',
		defaultMessage: 'Form view',
	},
	'finance-service-managementFeature-1': {
		id: 'jsm.templates.finance-service-management.feature-1',
		defaultMessage: 'Forms for Finance requests',
	},
	'finance-service-managementFeature-2': {
		id: 'jsm.templates.finance-service-management.feature-2',
		defaultMessage: 'Reporting and tracking',
	},
	'analytics-service-managementName': {
		id: 'jsm.templates.analytics-service-management.name',
		defaultMessage: 'Analytics service management',
	},
	'analytics-service-managementOneLinerHeadline': {
		id: 'jsm.templates.analytics-service-management.oneLinerHeadline',
		defaultMessage: 'Manage employee requests for the data and insights they need.',
	},
	'analytics-service-managementIconName': {
		id: 'jsm.templates.analytics-service-management.templateIcon.name',
		defaultMessage: 'Jira roadmap',
	},
	'analytics-service-managementIconDescription': {
		id: 'jsm.templates.analytics-service-management.templateIcon.description',
		defaultMessage: 'Jira roadmap',
	},
	'analytics-service-managementFeature-1': {
		id: 'jsm.templates.analytics-service-management.feature-1',
		defaultMessage: 'Self-service and FAQ help center',
	},
	'analytics-service-managementFeature-2': {
		id: 'jsm.templates.analytics-service-management.feature-2',
		defaultMessage: 'Automated Analytics workflows',
	},
	'facilities-service-managementName': {
		id: 'jsm.templates.facilities-service-management.name',
		defaultMessage: 'Facilities service management',
	},
	'facilities-service-managementOneLinerHeadline': {
		id: 'jsm.templates.facilities-service-management.oneLinerHeadline',
		defaultMessage: 'Manage requests for maintenance, moving, and event planning.',
	},
	'facilities-service-managementIconName': {
		id: 'jsm.templates.facilities-service-management.templateIcon.name',
		defaultMessage: 'Help center screenshot',
	},
	'facilities-service-managementIconDescription': {
		id: 'jsm.templates.facilities-service-management.templateIcon.description',
		defaultMessage: 'Help center screenshot',
	},
	'facilities-service-managementFeature-1': {
		id: 'jsm.templates.facilities-service-management.feature-1',
		defaultMessage: 'Forms for Facilities requests',
	},
	'facilities-service-managementFeature-2': {
		id: 'jsm.templates.facilities-service-management.feature-2',
		defaultMessage: 'Self-service and FAQ help center',
	},
	'sales-service-managementName': {
		id: 'jsm.templates.sales-service-management.name',
		defaultMessage: 'Sales service management',
	},
	'sales-service-managementOneLinerHeadline': {
		id: 'jsm.templates.sales-service-management.oneLinerHeadline',
		defaultMessage: 'Manage, track, and report on all your sales requests.',
	},
	'sales-service-managementIconName': {
		id: 'jsm.templates.sales-service-management.templateIcon.name',
		defaultMessage: 'Kanban board',
	},
	'sales-service-managementIconDescription': {
		id: 'jsm.templates.sales-service-management.template    .Icon.description',
		defaultMessage: 'Kanban board',
	},
	'sales-service-managementFeature-1': {
		id: 'jsm.templates.sales-service-management.feature-1',
		defaultMessage: 'Forms designed for Sales requests',
	},
	'sales-service-managementFeature-2': {
		id: 'jsm.templates.sales-service-management.feature-2',
		defaultMessage: 'Reporting and tracking',
	},
	'legal-service-managementName': {
		id: 'jsm.templates.legal-service-management.name',
		defaultMessage: 'Legal service management',
	},
	'legal-service-managementOneLinerHeadline': {
		id: 'jsm.templates.legal-service-management.oneLinerHeadline',
		defaultMessage: 'Manage and track all your contracts and legal requests.',
	},
	'legal-service-managementIconName': {
		id: 'jsm.templates.legal-service-management.templateIcon.name',
		defaultMessage: 'Jira roadmap',
	},
	'legal-service-managementIconDescription': {
		id: 'jsm.templates.legal-service-management.templateIcon.description',
		defaultMessage: 'Jira roadmap',
	},
	'legal-service-managementFeature-1': {
		id: 'jsm.templates.legal-service-management.feature-1',
		defaultMessage: 'Self-service and FAQ help center',
	},
	'legal-service-managementFeature-2': {
		id: 'jsm.templates.legal-service-management.feature-2',
		defaultMessage: 'Customer portal to take requests',
	},
	'general-service-managementName': {
		id: 'jsm.templates.general-service-management.name',
		defaultMessage: 'General service management',
	},
	'general-service-managementOneLinerHeadline': {
		id: 'jsm.templates.general-service-management.oneLinerHeadline',
		defaultMessage: 'Collect, prioritize, and manage requests for any business teams.',
	},
	'general-service-managementIconName': {
		id: 'jsm.templates.general-service-management.templateIcon.name',
		defaultMessage: 'Queues view',
	},
	'general-service-managementIconDescription': {
		id: 'jsm.templates.general-service-management.templateIcon.description',
		defaultMessage: 'Queues view',
	},
	'general-service-managementFeature-1': {
		id: 'jsm.templates.general-service-management.feature-1',
		defaultMessage: 'Self-service and FAQ help center',
	},
	'general-service-managementFeature-2': {
		id: 'jsm.templates.general-service-management.feature-2',
		defaultMessage: 'Customer portal to take requests',
	},
});

interface JiraServiceManagementTemplateMessagesType {
	name: MessageDescriptor;
	oneLinerHeadline: MessageDescriptor;
	iconName: MessageDescriptor;
	iconDescription: MessageDescriptor;
	keyFeatures: MessageDescriptor[];
}

export const JiraServiceManagementTemplateMessageMap = {
	'it-service-management': {
		name: JiraServiceManagementTemplateMessages['it-service-managementName'],
		oneLinerHeadline:
			JiraServiceManagementTemplateMessages['it-service-managementOneLinerHeadline'],
		iconName: JiraServiceManagementTemplateMessages['it-service-managementIconName'],
		iconDescription: JiraServiceManagementTemplateMessages['it-service-managementIconDescription'],
		keyFeatures: [
			JiraServiceManagementTemplateMessages['it-service-managementFeature-1'],
			JiraServiceManagementTemplateMessages['it-service-managementFeature-2'],
		],
	},
	'advanced-it-service-management': {
		name: JiraServiceManagementTemplateMessages['advanced-it-service-managementName'],
		oneLinerHeadline:
			JiraServiceManagementTemplateMessages['advanced-it-service-managementOneLinerHeadline'],
		iconName: JiraServiceManagementTemplateMessages['advanced-it-service-managementIconName'],
		iconDescription:
			JiraServiceManagementTemplateMessages['advanced-it-service-managementIconDescription'],
		keyFeatures: [
			JiraServiceManagementTemplateMessages['advanced-it-service-managementFeature-1'],
			JiraServiceManagementTemplateMessages['advanced-it-service-managementFeature-2'],
		],
	},
	'hr-service-management': {
		name: JiraServiceManagementTemplateMessages['hr-service-managementName'],
		oneLinerHeadline:
			JiraServiceManagementTemplateMessages['hr-service-managementOneLinerHeadline'],
		iconName: JiraServiceManagementTemplateMessages['hr-service-managementIconName'],
		iconDescription: JiraServiceManagementTemplateMessages['hr-service-managementIconDescription'],
		keyFeatures: [
			JiraServiceManagementTemplateMessages['hr-service-managementFeature-1'],
			JiraServiceManagementTemplateMessages['hr-service-managementFeature-2'],
		],
	},
	'customer-service-management': {
		name: JiraServiceManagementTemplateMessages['customer-service-managementName'],
		oneLinerHeadline:
			JiraServiceManagementTemplateMessages['customer-service-managementOneLinerHeadline'],
		iconName: JiraServiceManagementTemplateMessages['customer-service-managementIconName'],
		iconDescription:
			JiraServiceManagementTemplateMessages['customer-service-managementIconDescription'],
		keyFeatures: [
			JiraServiceManagementTemplateMessages['customer-service-managementFeature-1'],
			JiraServiceManagementTemplateMessages['customer-service-managementFeature-2'],
		],
	},
	'marketing-service-management': {
		name: JiraServiceManagementTemplateMessages['marketing-service-managementName'],
		oneLinerHeadline:
			JiraServiceManagementTemplateMessages['marketing-service-managementOneLinerHeadline'],
		iconName: JiraServiceManagementTemplateMessages['marketing-service-managementIconName'],
		iconDescription:
			JiraServiceManagementTemplateMessages['marketing-service-managementIconDescription'],
		keyFeatures: [
			JiraServiceManagementTemplateMessages['marketing-service-managementFeature-1'],
			JiraServiceManagementTemplateMessages['marketing-service-managementFeature-2'],
		],
	},
	'design-service-management': {
		name: JiraServiceManagementTemplateMessages['design-service-managementName'],
		oneLinerHeadline:
			JiraServiceManagementTemplateMessages['design-service-managementOneLinerHeadline'],
		iconName: JiraServiceManagementTemplateMessages['design-service-managementIconName'],
		iconDescription:
			JiraServiceManagementTemplateMessages['design-service-managementIconDescription'],
		keyFeatures: [
			JiraServiceManagementTemplateMessages['design-service-managementFeature-1'],
			JiraServiceManagementTemplateMessages['design-service-managementFeature-2'],
		],
	},
	'finance-service-management': {
		name: JiraServiceManagementTemplateMessages['finance-service-managementName'],
		oneLinerHeadline:
			JiraServiceManagementTemplateMessages['finance-service-managementOneLinerHeadline'],
		iconName: JiraServiceManagementTemplateMessages['finance-service-managementIconName'],
		iconDescription:
			JiraServiceManagementTemplateMessages['finance-service-managementIconDescription'],
		keyFeatures: [
			JiraServiceManagementTemplateMessages['finance-service-managementFeature-1'],
			JiraServiceManagementTemplateMessages['finance-service-managementFeature-2'],
		],
	},
	'analytics-service-management': {
		name: JiraServiceManagementTemplateMessages['analytics-service-managementName'],
		oneLinerHeadline:
			JiraServiceManagementTemplateMessages['analytics-service-managementOneLinerHeadline'],
		iconName: JiraServiceManagementTemplateMessages['analytics-service-managementIconName'],
		iconDescription:
			JiraServiceManagementTemplateMessages['analytics-service-managementIconDescription'],
		keyFeatures: [
			JiraServiceManagementTemplateMessages['analytics-service-managementFeature-1'],
			JiraServiceManagementTemplateMessages['analytics-service-managementFeature-2'],
		],
	},
	'facilities-service-management': {
		name: JiraServiceManagementTemplateMessages['facilities-service-managementName'],
		oneLinerHeadline:
			JiraServiceManagementTemplateMessages['facilities-service-managementOneLinerHeadline'],
		iconName: JiraServiceManagementTemplateMessages['facilities-service-managementIconName'],
		iconDescription:
			JiraServiceManagementTemplateMessages['facilities-service-managementIconDescription'],
		keyFeatures: [
			JiraServiceManagementTemplateMessages['facilities-service-managementFeature-1'],
			JiraServiceManagementTemplateMessages['facilities-service-managementFeature-2'],
		],
	},
	'sales-service-management': {
		name: JiraServiceManagementTemplateMessages['sales-service-managementName'],
		oneLinerHeadline:
			JiraServiceManagementTemplateMessages['sales-service-managementOneLinerHeadline'],
		iconName: JiraServiceManagementTemplateMessages['sales-service-managementIconName'],
		iconDescription:
			JiraServiceManagementTemplateMessages['sales-service-managementIconDescription'],
		keyFeatures: [
			JiraServiceManagementTemplateMessages['sales-service-managementFeature-1'],
			JiraServiceManagementTemplateMessages['sales-service-managementFeature-2'],
		],
	},
	'legal-service-management': {
		name: JiraServiceManagementTemplateMessages['legal-service-managementName'],
		oneLinerHeadline:
			JiraServiceManagementTemplateMessages['legal-service-managementOneLinerHeadline'],
		iconName: JiraServiceManagementTemplateMessages['legal-service-managementIconName'],
		iconDescription:
			JiraServiceManagementTemplateMessages['legal-service-managementIconDescription'],
		keyFeatures: [
			JiraServiceManagementTemplateMessages['legal-service-managementFeature-1'],
			JiraServiceManagementTemplateMessages['legal-service-managementFeature-2'],
		],
	},
	'general-service-management': {
		name: JiraServiceManagementTemplateMessages['general-service-managementName'],
		oneLinerHeadline:
			JiraServiceManagementTemplateMessages['general-service-managementOneLinerHeadline'],
		iconName: JiraServiceManagementTemplateMessages['general-service-managementIconName'],
		iconDescription:
			JiraServiceManagementTemplateMessages['general-service-managementIconDescription'],
		keyFeatures: [
			JiraServiceManagementTemplateMessages['general-service-managementFeature-1'],
			JiraServiceManagementTemplateMessages['general-service-managementFeature-2'],
		],
	},
} as const satisfies Record<string, JiraServiceManagementTemplateMessagesType>;
